export default __webpack_public_path__ + "assets/images/jackpot.614d7b.png";